module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_an-decf788f371c15898207bd5aa13d457e.svg";